module.exports = __webpack_public_path__ + "img/us-map-2_cropped-02.9daf523e.svg";